<template>
  <div class="box9-page">
    <div class="fcp-title">经验丰富且专业的讲师</div>
    <div class="fcp-text">成长与发展的动力助推师，品质教育，匠心做课</div>
    <div class="list-mask">
      <ul>
        <li 
          v-for="(item, index) in list" 
          :key="index"
          :style="{backgroundImage: `url(${require('../../../assets/coursePage/fcp/box9/card-bg-0' + (index + 1) + '.png')})`}"
        >
          <h2>{{ item.title }}</h2>
          <p v-html="item.info"></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        list:[
          {
            title: '赵老师',
            info: '大数据高级讲师 | 帆软认证<br/>培训讲师',
          },
          {
            title: '王老师',
            info: '资深大数据开发工程师 | 帆<br/>软认证培训讲师',
          },
          {
            title: '魏老师',
            info: '资深BI数据分析师 | 帆软<br/>认证培训讲师',
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
.box9-page{
  padding: 80px 0 88px;
  background-image: url(../../../assets/coursePage/fcp/box9/box9-bg.png);
  background-size: cover;
  .list-mask{
    width: 100%;
    margin-top: 48px;
    overflow-x: auto;
    overflow-y: hidden;
    height: 390px;
    ul{
      max-width: 994px;
      height: 430px;
      display: flex;
      padding: 0 48px 40px;
      overflow-x: auto;
      overflow-y: hidden;
      box-sizing: border-box;
      li{
        min-width: 310px;
        width: 310px;
        height: 390px;
        margin-right: 32px;
        box-sizing: border-box;
        background-size: 100% 100%;
        padding: 274px 0 0 24px;

        h2{
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 40px;
        }
        
        p{
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 28px;
        }

        &:last-child{
          margin: 0;
        }
      }
    }
  }
}
</style>